import TextInput from "components/common/custom/forms/BootTextField/TextField";
import MultiSelect from "components/common/MultiSelect";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Controller } from "react-hook-form";
import DurationMedicalHistory from "./DurationMedicalHistory";
import FrequencyMedicalHistory from "./FrequencyMedicalHistory";
import DoseMedicalHistory from "./DoseMedicalHistory";
import { useDispatch, useSelector } from "react-redux";
import { GetAllRoute } from "../config/preauthorizationApi";
import { motion } from "framer-motion";
import ServiceCodeSelect from "./ServiceCodeSelect";
import WizardModal from "components/wizard/WizardModal";

const MedicalHistoryMedicine = ({ control, watch, setValue }) => {
  const dispatch = useDispatch();
  const {
    scientificAbsnceReason,
    substituteReason,
    claimRequestData,
    selectReasonList,
    viewModal,
    serviceTypeList,
    routeList,
    stepFormData,
  } = useSelector((state) => state.preauthorization);
  const {
    viewModal: claimView,
    stepFormData: claimData,
    viewClaimInfo,
  } = useSelector((state) => state.claim);

  const payloadClaim = viewClaimInfo?.payload_json;

  const scientificAbsence = watch("scientic_code_absence");
  const pharmacistSubstitue = watch("pharmacist_substitute");
  const isPrescription =
    stepFormData?.prescription ||
    claimData?.prescription ||
    payloadClaim?.prescript_submt ||
    claimRequestData?.entry?.find(
      (item) => item?.resource?.resourceType === "Claim"
    )?.resource?.use === "predetermination" ||
    false;

  const showItem =
    isPrescription ||
    stepFormData?.claim_type?.claim_types_name === "pharmacy" ||
    watch("service_type")?.servtype_code === "itm_medcde" ||
    watch("service_type")?.servtype_code === "itm_hrblcde";

  const showScientificReasonInput = scientificAbsence?.absrsn_code === "others";
  const showSubstituteReasonInput =
    pharmacistSubstitue?.subsrsn_code === "Others";
  const [menuStates, setMenuStates] = useState(false);
  const [showServiceCodeModal, setShowServiceCodeMadal] = useState(false);

  const handleServiceMenuToggle = (isOpen) => {
    // 1) If opening and no service_type selected → show modal & DO NOT open dropdown
    if (isOpen && !watch("prescribed_medication_type")) {
      setShowServiceCodeMadal(true);
      return setMenuStates(isOpen);
    }

    // 2) Otherwise, allow the dropdown to open or close
    setMenuStates((prev) => ({ ...prev, type: isOpen }));
  };

  useEffect(() => {
    if (routeList?.length === 0) {
      dispatch(GetAllRoute());
    }
  }, [routeList]);

  return (
    <motion.div
      style={{ border: "2px solid #d9f8eb" }}
      className="rounded p-3 position-relative mt-3 mb-3"
      initial={{ opacity: 0, y: 50 }} // Starts faded out and moved down
      animate={{ opacity: 1, y: 0 }} // Fades in and moves to place
      exit={{ opacity: 0, y: 50 }} // Optional: for exit animation
      transition={{ duration: 0.5 }} // Smooth transition
    >
      {/* Floating Badge Header */}
      <div className="position-absolute top-0 start-45 translate-middle-y px-2 d-none d-md-block">
        <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
          <span className="fs-11">Medicine</span>
        </span>
      </div>
      <Row>
        <Col xs={12} sm={6} md={3} xl={2}>
          <label className="form-label">Prescribed Medication type</label>
          <Controller
            name="prescribed_medication_type"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isMulti={false}
                options={serviceTypeList?.map((item) => ({
                  value: item.servtype_code,
                  label: item.servtype_name,
                }))}
                disabled={viewModal || claimView}
                value={
                  field.value
                    ? {
                        value: field.value.servtype_code,
                        label: field.value.servtype_name,
                      }
                    : null
                }
                onChange={(selected) => {
                  setValue(
                    "prescribed_medication_type",
                    selected
                      ? {
                          servtype_code: selected.value,
                          servtype_name: selected.label,
                        }
                      : null
                  );
                }}
                formatOptionLabel={({ label }) => <div>{label}</div>}
                getOptionValue={(option) => option.value}
                placeholder="Choose ..."
              />
            )}
          />
        </Col>
        <Col xs={12} sm={6} md={3} xl={2}>
          <ServiceCodeSelect
            control={control}
            label="Prescribed Medication Code"
            name="prescribed_medication_code"
            isRequired={false}
            selectedServiceType={
              watch("prescribed_medication_type")?.servtype_code
            }
            medication
            setValue={setValue}
            watch={watch}
            handleServiceMenuToggle={handleServiceMenuToggle}
          />
        </Col>
        <Col xs={12} sm={6} md={3} xl={2}>
          <TextInput
            name="scientific_code"
            disabled={
              viewModal || claimView || (!isPrescription && scientificAbsence)
            }
            label="Scientific Code"
            control={control}
            size="sm"
          />
        </Col>

        <Col
          xs={12}
          sm={showScientificReasonInput || showSubstituteReasonInput ? 6 : 12}
          md={showScientificReasonInput || showSubstituteReasonInput ? 3 : 6}
          xl={showScientificReasonInput || showSubstituteReasonInput ? 2 : 4}
        >
          <label className="form-label">
            Scientific Code Absence Reason{" "}
            {isPrescription && !watch("scientific_code") && (
              <span className="text-danger">*</span>
            )}
          </label>
          <Controller
            name="scientic_code_absence"
            control={control}
            rules={{ required: isPrescription && !watch("scientific_code") }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isClearable={true}
                disabled={
                  viewModal ||
                  claimView ||
                  (!isPrescription && watch("scientific_code"))
                }
                isMulti={false}
                options={scientificAbsnceReason.map((item) => ({
                  value: item.absrsn_code,
                  label: item.absrsn_name,
                }))}
                value={
                  field.value
                    ? {
                        value: field.value.absrsn_code,
                        label: field.value.absrsn_name,
                      }
                    : null
                }
                onChange={(selected) => {
                  setValue(
                    "scientic_code_absence",
                    selected
                      ? {
                          absrsn_code: selected.value,
                          absrsn_name: selected.label,
                        }
                      : null
                  );
                }}
                formatOptionLabel={({ label }) => <div>{label}</div>}
                getOptionValue={(option) => option.value}
                placeholder="Choose ..."
              />
            )}
          />
        </Col>

        {showScientificReasonInput && (
          <Col xs={12} sm={6} md={3} xl={2}>
            <TextInput
              name="scientific_code_other_reason"
              label="Scientific Absence Reason"
              control={control}
              size="sm"
              type="text"
              rules={{ required: showScientificReasonInput }}
              required={showScientificReasonInput}
            />
          </Col>
        )}

        <Col xs={12} sm={6} md={3} xl={2}>
          <TextInput
            name="strength"
            label="Strength"
            size="sm"
            control={control}
            disabled={true}
          />
        </Col>

        <Col xs={12} sm={6} md={4} xl={2}>
          <label className="form-label">
            Selection Reason{" "}
            {(watch("service_type")?.servtype_code === "itm_medcde" ||
              watch("service_type")?.servtype_code === "itm_hrblcde") && (
              <span className="text-danger">*</span>
            )}
          </label>
          <Controller
            name="selection_reason"
            control={control}
            rules={{
              required:
                watch("service_type")?.servtype_code === "itm_medcde" ||
                watch("service_type")?.servtype_code === "itm_hrblcde",
            }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                menuPlacement="auto"
                isClearable={true}
                closeMenuOnSelect={false}
                disabled={viewModal || claimView}
                isMulti={false}
                options={selectReasonList.map((item) => ({
                  value: item.pharmselrsn_code,
                  label: item.pharmselrsn_disply,
                }))}
                value={
                  field.value
                    ? {
                        value: field.value.pharmselrsn_code,
                        label: field.value.pharmselrsn_disply,
                      }
                    : null
                }
                onChange={(selected) => {
                  setValue(
                    "selection_reason",
                    selected
                      ? {
                          pharmselrsn_code: selected.value,
                          pharmselrsn_disply: selected.label,
                        }
                      : null
                  );
                }}
                formatOptionLabel={({ label }) => <div>{label}</div>}
                getOptionValue={(option) => option.value}
                placeholder="Choose ..."
              />
            )}
          />
        </Col>

        <Col xs={12} sm={6} md={4} xl={2}>
          <label className="form-label">Pharmacist Substitute</label>
          <Controller
            name="pharmacist_substitute"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                disabled={viewModal || claimView}
                isMulti={false}
                options={substituteReason?.map((item) => ({
                  value: item.subsrsn_code,
                  label: item.subsrsn_name,
                }))}
                isClearable={true}
                value={
                  field.value
                    ? {
                        value: field.value.subsrsn_code,
                        label: field.value.subsrsn_name,
                      }
                    : null
                }
                onChange={(selected) => {
                  setValue(
                    "pharmacist_substitute",
                    selected
                      ? {
                          subsrsn_code: selected.value,
                          subsrsn_name: selected.label,
                        }
                      : null
                  );
                }}
                formatOptionLabel={({ label }) => <div>{label}</div>}
                getOptionValue={(option) => option.value}
                placeholder="Choose ..."
              />
            )}
          />
        </Col>
        {showSubstituteReasonInput && (
          <Col xs={12} sm={6} md={4} xl={2}>
            <TextInput
              name="substitute_reason_other"
              label="Substitute Reason"
              control={control}
              size="sm"
              type="text"
              rules={{ required: showSubstituteReasonInput }}
              required={showSubstituteReasonInput}
            />
          </Col>
        )}
        {showItem && (
          <Col xs={12} className="mt-3">
            <Row>
              <DurationMedicalHistory
                watch={watch}
                control={control}
                setValue={setValue}
              />
              <FrequencyMedicalHistory
                watch={watch}
                control={control}
                setValue={setValue}
              />
              <DoseMedicalHistory
                watch={watch}
                control={control}
                setValue={setValue}
              />
            </Row>
          </Col>
        )}
        {showItem && (
          <Col xs={12}>
            <Row>
              <Col xs={12} sm={6} md={3}>
                <label className="form-label mb-2">
                  Route{" "}
                  {isPrescription && <span className="text-danger">*</span>}
                </label>
                <Controller
                  name="route"
                  control={control}
                  rules={{ required: isPrescription }}
                  render={({ field }) => (
                    <MultiSelect
                      {...field}
                      menuPlacement="top"
                      closeMenuOnSelect={false}
                      disabled={viewModal || claimView}
                      isMulti={false}
                      options={routeList.map((item) => ({
                        value: item.ruteadmn_code,
                        label: item.ruteadmn_name,
                      }))}
                      value={
                        field.value
                          ? {
                              value: field.value.ruteadmn_code,
                              label: field.value.ruteadmn_name,
                            }
                          : null
                      }
                      isClearable={true}
                      onChange={(selected) => {
                        setValue(
                          "route",
                          selected
                            ? {
                                ruteadmn_code: selected.value,
                                ruteadmn_name: selected.label,
                              }
                            : null
                        );
                      }}
                      formatOptionLabel={({ label }) => <div>{label}</div>}
                      getOptionValue={(option) => option.value}
                      placeholder="Choose ..."
                    />
                  )}
                />
              </Col>
              <Col xs={12} sm={6} md={3}>
                <label className="form-label mb-2">Time Instruction </label>
                <Controller
                  name="time_instruction"
                  control={control}
                  rules={{ required: false }}
                  render={({ field }) => (
                    <MultiSelect
                      {...field}
                      menuPlacement="auto"
                      closeMenuOnSelect={false}
                      disabled={viewModal || claimView}
                      isMulti={false}
                      options={timeInstruction.map((item) => ({
                        value: item.time_instCode,
                        label: item.time_instDisplay,
                      }))}
                      value={
                        field.value
                          ? {
                              value: field.value.time_instCode,
                              label: field.value.time_instDisplay,
                            }
                          : null
                      }
                      onChange={(selected) => {
                        setValue(
                          "time_instruction",
                          selected
                            ? {
                                time_instCode: selected.value,
                                time_instDisplay: selected.label,
                              }
                            : null
                        );
                      }}
                      formatOptionLabel={({ label, value }) => (
                        <div>
                          {label} ({value})
                        </div>
                      )}
                      getOptionValue={(option) => option.value}
                      placeholder="Choose ..."
                    />
                  )}
                />
              </Col>
              <Col xs={12} sm={6} md={3}>
                <TextInput
                  name="refill_count"
                  label="Refill Count"
                  disabled={viewModal || claimView}
                  control={control}
                  size="sm"
                  type="number"
                  min={0}
                />
              </Col>
            </Row>
          </Col>
        )}
        {showItem && (
          <Col xs={12}>
            <Row>
              <Col xs={12} sm={6} xl={4}>
                <TextInput
                  name="dosage_instruction"
                  label="Dosage Instruction"
                  size="sm"
                  disabled={viewModal || claimView}
                  control={control}
                  multiline={true}
                  rows={2}
                  //   colSize={3}
                />
              </Col>
              <Col xs={12} sm={6} xl={4}>
                <TextInput
                  name="patient_instruction"
                  label="Patient Instruction"
                  size="sm"
                  control={control}
                  disabled={viewModal || claimView}
                  multiline={true}
                  rows={2}
                  //   colSize={3}
                />
              </Col>
            </Row>
          </Col>
        )}
      </Row>
      <WizardModal
        modal={showServiceCodeModal}
        setModal={setShowServiceCodeMadal}
        title="Service Type Not Selected"
        description={
          "Please select Service Type first before choosing Service code / description"
        }
      />
    </motion.div>
  );
};

export default MedicalHistoryMedicine;

const timeInstruction = [
  {
    time_instCode: "BID",
    time_instDisplay: "Two time a day",
  },
  {
    time_instCode: "TID",
    time_instDisplay: "Three time a day",
  },
  {
    time_instCode: "QID",
    time_instDisplay: "Four time a day",
  },
  {
    time_instCode: "AM",
    time_instDisplay: "Every Morning",
  },
  {
    time_instCode: "PM",
    time_instDisplay: "Every Afternoon",
  },
  {
    time_instCode: "QD",
    time_instDisplay: "Every day",
  },
  {
    time_instCode: "QOD",
    time_instDisplay: "Every Other day",
  },
];
